import { renderToStaticMarkup } from 'react-dom/server';

import common from '../translations/common.json';
import dashboard from '../translations/dashboard.json';
import userAnalytics from '../translations/userAnalytics.json';
import userList from '../translations/userList.json';
import inviteUser from '../translations/inviteUser.json';
import bulkUpload from '../translations/bulkUpload.json';
import userDetail from '../translations/userDetail.json';
import message from '../translations/message.json';
import maintenanceMode from '../translations/maintenanceMode.json';
import dataExport from '../translations/dataExport.json';
import teamInformation from '../translations/teamInformation.json';
import userPermission from '../translations/userPermission.json';
import whiteLabel from '../translations/whiteLabel.json';

export const SITE_DEFAULT_LANGUAGE = 'en';
export const SITE_FRENCH_LANGUAGE = 'fr';
export const DEFAULT_LANGUAGE_TEXT = 'English';
export const FRENCH_LANGUAGE_TEXT = 'Français';

export const languageList = [
  { name: DEFAULT_LANGUAGE_TEXT, code: SITE_DEFAULT_LANGUAGE },
  { name: FRENCH_LANGUAGE_TEXT, code: SITE_FRENCH_LANGUAGE },
];

// Init local language
export const languageInit = language => ({
  languages: languageList,
  translation: {
    ...common,
    ...dashboard,
    ...userAnalytics,
    ...userList,
    ...inviteUser,
    ...bulkUpload,
    ...userDetail,
    ...message,
    ...maintenanceMode,
    ...dataExport,
    ...teamInformation,
    ...userPermission,
    ...whiteLabel,
  },
  options: {
    defaultLanguage: !language ? SITE_DEFAULT_LANGUAGE : language,
    renderToStaticMarkup,
  },
});
